import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"position":"relative","user-select":"none"} }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  style: {"position":"fixed","bottom":"48px","width":"100%"}
}
const _hoisted_4 = { style: {"width":"98%","padding":"8px","display":"flex","margin":"auto","align-items":"center","background-color":"rgba(231, 231, 231, 0.95)","border":"1px solid #CCC"} }
const _hoisted_5 = ["src"]
const _hoisted_6 = { style: {"margin-right":"auto","padding-left":"12px"} }
const _hoisted_7 = { class: "user-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      class: _normalizeClass(_ctx.iframeClass),
      style: _normalizeStyle([{"border":"none","margin":"auto","display":"block","user-select":"none"}, {'min-height': _ctx.iframeMinHeight, 'height':_ctx.contentsHeight, 'width':_ctx.contentsWidth}]),
      src: _ctx.kiwiIframeURL,
      frameborder: "1",
      scrolling: "no",
      id: "viewIframe",
      allow: "autoplay;camera *;microphone *;geolocation;"
    }, null, 14, _hoisted_2),
    _createVNode(_component_Loading, {
      ref: "loading",
      class: "loading",
      fadein: false
    }, null, 512),
    (_ctx.comment)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              class: "comment-image",
              style: _normalizeStyle([{"border-radius":"50%"}, {marginLeft: 'auto'}]),
              src: _ctx.urls.getUserImageSrc(_ctx.publicPageData.user),
              alt: "username"
            }, null, 8, _hoisted_5),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.publicPageData.user.userName), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.comment), 1)
            ]),
            _createElementVNode("div", {
              style: {"cursor":"pointer","user-select":"none","font-size":"x-large","padding":"0 16px 4px"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.comment=''))
            }, " × ")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}